module.exports = __webpack_public_path__ + "dabb91bbfc990fca2df33bbeeaa876d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/harvard_university_2023_chart.png
// module id = 1684
// module chunks = 0